module.exports = __webpack_public_path__ + "static/img/2.2ab6a366.png";